import axios from 'axios';
//Backed API//Web Service //Web Api call will be here
const getNotes=async ()=>{
try{
const URL=process.env.REACT_APP_NOTES_URL
const response=await axios.get(URL);
console.log("#######");
console.log(response.data);
return response.data.notes;
}catch(err){
    console.log("Error in URL1");
throw err;
}}
export default getNotes